import React from 'react';

// The question as an ordinary section heading, the answer as the headline under it
export default function Verdict({ verdict, heading = 'Is the ad spend worth it?', className = '', children }) {
  const icon = { good: '✓', warn: '!', bad: '✕', info: 'i' }[verdict.status];
  return (
    <section className={`pf-section pf-verdict ${verdict.status} ${className}`}>
      <h2 className="pf-verdict-question">{heading}</h2>
      <div className="pf-verdict-title">
        <span className="pf-verdict-icon" aria-hidden="true">{icon}</span>
        {verdict.title}
      </div>
      <p className="pf-verdict-text">{verdict.text}</p>
      {verdict.figures && (
        <div className="pf-figures">
          {verdict.figures.map(f => (
            <div key={f.label} className="pf-figure">
              <div className="pf-tile-label">{f.label}</div>
              <div className="pf-figure-value">{f.value}</div>
              {f.note && <div className="pf-figure-note">{f.note}</div>}
            </div>
          ))}
        </div>
      )}
      {children}
    </section>
  );
}
